export default "__VITE_ASSET__CqBsseLs__"